import React, { useCallback } from "react";
import { useNavigate } from "react-router";
import { Button } from "@companion-core/shared/app/Components/Button";
import { SlideProps } from "./slide.model";
import { useMediaQuery } from "@companion-core/web/src/Utilities/mediaQuery";
import { getCloudinaryOptimizedUrl } from "@companion-core/shared/app/Utils/cloudinary";
import { getSanitizedDescriptionAlt } from "@companion-core/shared/app/Utils/componentHelper";
import { sanitizeHtml } from "@companion-core/shared/app/Utils/htmlSanitizer";
import "@companion-core/web/src/Assets/Styles/scss/slide.scss";

export const Slide = ({ slide }: SlideProps) => {
  const navigate = useNavigate();
  const image = slide.medias?.[0];
  const imageContent = image?.url;
  const isMobileSize = useMediaQuery("(max-width: 768px)");

  const handleButtonClick = useCallback(() => {
    const link = slide.button_link;
    const type = slide.button_type ?? "external";

    if (type === "internal" || type === "dynamic") {
      navigate(link ?? "", { state: { canGoBack: true } });
      return;
    }

    window.open(link, "_blank", "noopener,noreferrer");
  }, [navigate, slide.button_link, slide.button_type]);

  return (
    <section className="slide d-flex justify-content-center align-items-center position-relative w-100">
      <div className="opacity-0 transition-1-ease mh-inherit w-100 h-100 opacity-1 transition-1">
        {/* Image */}
        <div className="slide-background w-100 h-100">
          <img
            src={getCloudinaryOptimizedUrl(imageContent ?? "", {
              contentType: "banner",
              width: window.innerWidth,
              height: isMobileSize ? 390 : undefined,
            })}
            className="slide-img w-100 h-100"
            alt={getSanitizedDescriptionAlt(image?.description_alt) ?? ""}
          />
        </div>
        {/* Info */}
        <div className="info d-flex flex-direction-column justify-content-center position-absolute top-50 transform-y-50 box-sizing-border">
          <span
            className="slide__title title-7"
            // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(slide.title) }}
          />
          {slide.subtitle && (
            <span
              className="slide__subtitle body-text-2"
              // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(slide.subtitle) }}
            />
          )}
          {/* Show description when is mobile size <= 768px */}
          {!isMobileSize && slide.description && (
            <span
              className="slide__description body-text-4 max-line-5"
              // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(slide.description) }}
            />
          )}
          {slide.button_title && (
            <div className="slide__button align-self-center">
              <Button
                testID="slide__button"
                type="primary"
                negative={!!isMobileSize}
                size="large"
                label={slide.button_title}
                onClick={handleButtonClick}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
